var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isPendingEnvelopeProgress)?_c(_setup.ProgressLayout,{attrs:{"steps":_setup.steps},on:{"goToStep":_setup.goToStep}},[_c('KeepAlive',{attrs:{"include":_setup.keepAliveComponentNames}},[_c('RouterView')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }